import { Activite, ActiviteDTO } from "@/models";

/** Maps an {@link Activite} (as loaded from the store) to the DTO shape expected by create/update calls. */
export const mapOutActivite = (activite: Activite): ActiviteDTO => {
  return {
    libelle: activite.libelle ?? "",
    debut: activite.debut ?? "",
    fin: activite.fin ?? "",
    do_etat: activite.do?.id ?? "",
    etat_id: "OPEN",
    type_id: activite.type?.id ?? "",
    lieu: activite.lieu ?? "",
    reversion: activite.reversion ?? "",
  };
};
